import React from "react";

export default function Time(props){
    return(
        <div className="time">
            <div className="card">
                <div className="anmation">
                    {props.time}
                </div>
            </div>
            <p className="card-text">{props.title}</p>
        </div>
    )
}